import type { SliderProps } from "@mui/material";
import { Slider, styled } from "@mui/material";

const Root = styled(Slider)(({ theme }) => ({
  alignSelf: "center",
  width: `calc(100% - ${theme.spacing(2.5)})`,
}));

export function ControlsSlider({
  value,
  onChange,
  min,
  max,
  step,
  formatValue,
}: {
  value: number;
  onChange: (value: number) => void;
  formatValue?: (value: number) => string;
} & Pick<SliderProps, "min" | "max" | "step">) {
  function handleChange(_: unknown, value: number | Array<number>): void {
    onChange(value as number);
  }

  return (
    <Root
      value={value}
      onChange={handleChange}
      min={min}
      max={max}
      step={step}
      valueLabelDisplay="auto"
      valueLabelFormat={formatValue}
    />
  );
}
